import styled from 'styled-components'

export const InputWrapper = styled.div`
  display: grid;
  gap: 8px;
  width: 195px;
  position: relative;
`

export const InputRadioWrapper = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: auto 1fr;
`

export const InputRadioGrupo = styled.div`
  display: grid;
  gap: 8px;
  height: 100%;
  align-items: center;
`

export const Erro = styled.p`
  position: absolute;
  color: ${({ theme }) => theme.inputBorderError} !important;
  font-size: 12px;
  bottom: -25px;
  margin: 0;
`

export const RightSection = styled.div`
  color: ${({ theme }) => theme.cor9}!important;
  margin-right: 15px;
`
